<template>
  <div class="deposit-amount">
    <p :class="[{'required-flag': canUpdate}, 'blod-p']">
      {{ $t('tenantProjects.depositAmount') }}
    </p>
    <div
      v-if="isEngineer"
      class="btns"
    >
      <div class="notify-btns">
        <button
          v-if="canUpdate && !canNotifyAccounting"
          class="btn btn--darkblue"
          @click="notifyPM"
        >{{ $t('tenantProjects.notifyPM') }}</button>
        <button
          v-if="canNotifyAccounting && !isWaived"
          class="btn btn--darkblue margin-left-15"
          @click="notifyAccounting"
        >{{ $t('tenantProjects.notifyAccounting') }}</button>
        <button
          v-if="canNotifyAccounting && isWaived"
          class="btn btn--orange margin-left-15"
          @click="confirm"
        >{{ $t('action.confirm') }}</button>
        <div
          class="deposit-notify-info"
        >
          <i
            v-if="notifyPMInfo && canRead"
            class="gray-font notify-pm-info"
          >
            {{ $t('tenantProjects.notifyPMByAt', [notifyPMInfo.by, notifyPMInfo.time]) }}
          </i>
          <i
            v-if="notifyAccountingInfo"
            class="gray-font notify-accounting-info"
          >
            {{ $t('tenantProjects.notifyAccountingByAt', [notifyAccountingInfo.by, notifyAccountingInfo.time]) }}
          </i>
          <i
            v-if="confirmInfo && canRead"
            class="gray-font confirm-info"
          >
            {{ $t('tenantProjects.confirmByAt', [confirmInfo.by, confirmInfo.time]) }}
          </i>
          <HKLViewLayout
            v-if="notifyAccountingInfo"
            :checkIsHKL="true"
          >
            <a
              class="text-[12px] underline"
              @click="() => openDepositModal()"
            >
              {{ $t('tenantProjects.depositHistory') }}
            </a>
          </HKLViewLayout>
        </div>
      </div>
      <div
        v-if="enableWorkPermitsFeature"
        class="notify-contractor"
      >
        <HKLButton
          v-if="canUpdate"
          action="allowRefund"
          color="darkblue"
          @click="allowContractorRefund"
        >
          {{ $t('tenantProjects.notifyContractor') }}
        </HKLButton>
        <div
          v-if="allowContrRefundInfo"
          class="deposit-notify-info"
        >
          <i class="gray-font">
            {{ $t('tenantProjects.allowContractorRefundByAt', [allowContrRefundInfo.by, allowContrRefundInfo.time]) }}
          </i>
        </div>
      </div>
    </div>
    <div
      v-if="isEngineer"
      class="deposit-amount__content"
    >
      <div class="choose-deposit-amount">
        <input
          v-model="isWaived"
          type="radio"
          :value="false"
          :disabled="!canUpdate"
          @change="scheduleDirtyStateCheck"
        >
        <label class="deposit-amount-label">{{ $t('tenantProjects.depositAmount') }} </label>
        <label class="deposit-amount-label currency-prefix">{{ $globalProps.getCurrency() }}</label>
        <InputField
          class="input-deposit-amount"
          :readonly="!canUpdate && !isEditingAmount"
          :showColon="false"
          :placeholder="'0.00'"
          :showFlag="false"
          :value="amount"
          :showEmptyDash="true"
          :readonlyAsInput="isWaived || (isNotifiedPM && !isEditingAmount)"
          :inputTip="hintString"
          :inputCheckType="'decimal'"
          :pattern="regex.decimal"
          :required="!isWaived"
          :parentNode="FORM_SRC_PROJECT_CONTROL"
          @updateValue="val => updateAmount(val)"
        />
        <i
          v-show="isNotifiedPM && !isEditingAmount && !isWaived && canUpdate"
          class="fa fa-pencil"
          @click="isEditingAmount = true"
        />
      </div>
      <div class="waived-option">
        <input
          v-model="isWaived"
          type="radio"
          :value="true"
          :disabled="!canUpdate"
          @click="resetAmount"
          @change="scheduleDirtyStateCheck"
        >
        <label class="deposit-amount-label">{{ $t('tenantProjects.waiveDepositWithExtra') }}</label>
      </div>
      <div
        v-if="!isWaived"
        class="waived-option"
      >
        <p :class="[{'required-flag': canUpdate}, 'blod-p']">
          {{ $t('tenantProjects.debitNote') }}
        </p>
        <span class="plsSendTo">{{ $t('tenantProjects.plsSendTo') }}</span>
        <div>
          <input
            v-model="isDirect"
            type="radio"
            :value="true"
            :disabled="!canUpdate"
            @click="resetTenantMailing"
            @change="scheduleDirtyStateCheck"
          >
          <label class="deposit-amount-label">{{ $t('tenantProjects.TenantAddress') }}</label>
        </div>
        <div :class="[{'error-highlight': buildingErr}, 'tenant-mailing-address']">
          <input
            v-model="isDirect"
            type="radio"
            :value="false"
            :disabled="!canUpdate"
            @change="scheduleDirtyStateCheck"
          >
          <InputField
            :placeholder="$t('tenantProjects.staffNamePH')"
            :class="mailInputClass"
            :readonly="!canUpdate"
            :showColon="false"
            :showFlag="false"
            :value="payeeName"
            :readonlyAsInput="isDirect"
            :required="!isDirect"
            :parentNode="FORM_SRC_PROJECT_CONTROL"
            @updateValue="val => updatePayeeName(val)"
          />
          <span>{{ $t('at') }}</span>
          <HKLSelect
            class="tenant-mailing-address__buidling"
            :value="address || undefined"
            :options="buildingHklOptions"
            :showSearch="true"
            placeholder=""
            :disabled="isDirect || !canUpdate"
            @change="val => updateAddress(val)"
          />
          <span>{{ $t('tenantProjects.byInternalMail') }}</span>
        </div>
      </div>
    </div>
    <div v-else-if="isUserNotifyAccounting">
      <label class="medium-size margin-right-15">{{ $globalProps.getCurrency() + ' ' }} <span class="blod-p">{{ showAmount }}</span></label>
    </div>
    <div v-else>
      {{ $t('emptyValue') }}
    </div>

    <Modal
      ref="deposit-input-modal"
      modalType="small-modal"
      class="deposit-input-modal"
      :showCloseBtn="false"
      :modalId="`deposit-input-modal_${tenantProjectId}`"
    >
      <p
        slot="content"
        class="font-bold"
      >
        {{ $t('tenantProjects.inputAccountingHint') + ' ' }}
        <span>{{ accountingEmail || '--' }}</span>
      </p>
      <div slot="btns">
        <button
          class="btn--darkblue"
          @click="closeModal"
        >{{ $t('action.cancel') }}</button>
        <button
          class="btn--orange"
          @click="sendEmailToAccounting"
        >{{ $t('action.send') }}</button>
      </div>
    </Modal>
    <HKLModal
      v-if="isUserNotifyAccounting"
      ref="depositModal"
      size="large"
      :hasCancelBtn="false"
      :title="$t('tenantProjects.depositHistory')"
    >
      <HKLTable
        :columns="columns"
        :dataSource="parsedHistories"
      />
    </HKLModal>
  </div>
</template>

<script>
import CurrencyFormatter from 'currency-formatter'
import lodash from 'lodash'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { computed, getCurrentInstance } from 'vue-demi'
import dateUtil from '@/utils/dateUtil'
import InputField from '@/controls/InputField'
import mutationTypes from '@/store/mutation-types'
import HKLSelect from '@/controls/Select/HKLSelect.vue'
import Modal from '@/controls/Modal'
import * as regex from '@/utils/regex'
import * as tenantProjectApi from '@/api/tenantProjects/request'
import { EmailTypes } from '@/utils/consts'
import { fusionInputCheckUtil } from '@/plugin/FusionInputCheck'
import { getBuildingFloorZoneMap } from '@/api/buildings/request'
import { getRegionEnvsByCode } from '@/api/settings/request'
import { buildEmails, sendEmail } from '@/api/postman/request'
import { utils as formUtils } from '@/plugin/InputChange'
import notification from '@/utils/notification'
import HKLTable from '@/controls/Table/HKLTable.vue'
import HKLViewLayout from '@/controls/Layout/HKLViewLayout.vue'
import HKLButton from '@/controls/Button/HKLButton.vue'
import HKLModal from '@/controls/Modal/HKLModal.vue'
import { useRefModal } from '@/controls/Modal/modal.hook'
import { useStoreGetters } from '@/store/index'
import i18n from '@/utils/i18n'
import { DEPOSIT_HISTORY_TYPE } from './consts'
import { validateProjectControlFieldsOnLoad } from '../fieldValidationOnLoad'
import { FORM_SRC_PROJECT_CONTROL } from '../consts'
import { buildDepositNotifyAccountingEmailPayload, buildDirtyFieldSaveRequest, getModifiedSaveFields, initTenantProjectDepositSync, isPersistableDepositRefundAmount, normalizeDepositAmount, pickSaveFieldValues, reloadTenantProjectOnDepositSync, syncAllowContractorRefund, syncDepositNotifyAccounting, syncNotifyPm, syncSaveDepositAmount, validateModifiedSaveFields } from './sync.service'
import { TENANT_PROJECT_DEPOSIT_SYNC_ACTION } from './sync'

const DEPOSIT_SAVE_FIELDS = ['isWaived', 'isDirect', 'amount', 'payeeName', 'address']

const DEPOSIT_SAVE_FIELD_VALIDATORS = {
  amount: {
    when: context => !context.isWaived,
    inputSelector: '.input-deposit-amount',
    validSelector: '.deposit-amount',
  },
  payeeName: { group: 'mailing' },
  address: { group: 'mailing' },
}

const DEPOSIT_SAVE_VALIDATOR_GROUPS = {
  mailing: {
    when: context => !context.isDirect,
    inputSelector: '.tenant-mailing-address',
    validSelector: '.tenant-mailing-address',
  },
}

export default {
  name: 'DepositAmount',
  components: {
    HKLButton,
    HKLSelect,
    InputField,
    Modal,
    HKLModal,
    HKLViewLayout,
    HKLTable,
  },
  props: {
    // Below permissions are for HKLand staff
    canUpdate: Boolean,
    canNotifyAccounting: Boolean,
    canRead: Boolean,
    chequeFiles: {
      type: Array,
      default: () => [],
    },
  },
  setup (props) {
    let returnData = {}
    const { proxy } = getCurrentInstance()

    const { enableWorkPermitsFeature } = useStoreGetters('regions', ['enableWorkPermitsFeature'])
    const mailInputClass = computed(() => {
      return {
        'tenant-mailing-address-ro': !props.canUpdate,
        'input-tenant-mailing-address': props.canUpdate,
      }
    })
    returnData = {
      ...returnData,
      mailInputClass,
      enableWorkPermitsFeature,
    }

    const modals = useRefModal()
    const columns = computed(() => [
      {
        dataIndex: 'updatedAt',
        title: i18n.t('table.header.date'),
      },
      {
        dataIndex: 'previous',
        title: i18n.t('tenantProjects.previousDepositAmount'),
      },
      {
        dataIndex: 'difference',
        title: i18n.t('tenantProjects.difference'),
      },
      {
        dataIndex: 'total',
        title: i18n.t('tenantProjects.totalDepositAmount'),
      },
      {
        dataIndex: 'updatedBy',
        title: i18n.t('table.header.actionBy'),
      },
    ])
    const { depositRef } = useStoreGetters('tenantProject', ['deposit'])
    const depositHistoriesRef = computed(() => {
      return lodash.get(depositRef.value, 'actionHistory', [])
    })
    const parsedHistories = computed(() => {
      let list = depositHistoriesRef.value
      list = lodash.orderBy(list, ['updatedAt'], ['asc'])
      return list
        .filter(item => item.actionType === DEPOSIT_HISTORY_TYPE.notifyAccounting)
        .map((item, index, array) => {
          const total = +item.amount
          const previous = index === 0 ? 0 : +array[index - 1].amount
          const difference = total - previous
          const symbol = difference >= 0 ? '+' : '-'
          return {
            updatedAt: dateUtil.formatDate(item.updatedAt, true),
            updatedBy: item.user.displayName,
            difference: `${symbol}${proxy.$globalProps.getCurrency()}${Math.abs(difference)}`,
            previous: `${proxy.$globalProps.getCurrency()}${previous}`,
            total: `${proxy.$globalProps.getCurrency()}${total}`,
          }
        })
        .reverse()
    })
    returnData = {
      ...returnData,
      columns,
      parsedHistories,
      depositModal: modals.modal,
      openDepositModal: modals.open,
    }

    return returnData
  },
  data () {
    return {
      isWaived: false,
      isDirect: true,
      isEditingAmount: false,
      amount: '',
      payeeName: '',
      address: '',
      buildingOptions: [],
      regex,
      buildingErr: false,
      accountingEmail: '',
      tenantProjectId: '',
      hintString: this.$t('hint.inputTip.string'),
      hintEmail: this.$t('hint.inputTip.email'),
      FORM_SRC_PROJECT_CONTROL,
    }
  },
  computed: {
    ...mapGetters('user', ['isTenant', 'currentUser', 'isEngineer']),
    ...mapGetters('tenantProject', ['currentTenantProject', 'deposit']),
    buildingHklOptions () {
      return (this.buildingOptions || []).map((name) => ({ name, value: name }))
    },
    showAmount () {
      let showValue = this.$t('emptyValue')
      const actionHistory = lodash.get(this.deposit, 'actionHistory', [])
      const lastAmount = actionHistory.find(history => history.actionType === 'notifyAccounting')
      if (this.isWaived) {
        showValue = this.$t('na')
      } else if (lastAmount && lodash.isNumber(parseFloat(lastAmount.amount))) {
        showValue = CurrencyFormatter.format(lastAmount.amount, 'USD')
      }
      return showValue
    },
    isNotifiedPM () {
      return !!lodash.get(this, 'notifyPMInfo.time')
    },
    notifyPMInfo () {
      return this.getNotifyInfo(DEPOSIT_HISTORY_TYPE.notifyPM)
    },
    notifyAccountingInfo () {
      return this.getNotifyInfo(DEPOSIT_HISTORY_TYPE.notifyAccounting)
    },
    confirmInfo () {
      return this.getNotifyInfo(DEPOSIT_HISTORY_TYPE.confirm)
    },
    allowContrRefundInfo () {
      return this.getNotifyInfo(DEPOSIT_HISTORY_TYPE.allowContractorRefund)
    },
    isUserNotifyAccounting () {
      return !!this.notifyAccountingInfo
    },
    isShowUpdateTime () {
      if (this.isTenant && !this.notifyAccountingInfo) {
        return null
      } else {
        return this.deposit && this.deposit.updatedAt
      }
    },
  },
  watch: {
    deposit: {
      handler () {
        const data = lodash.cloneDeep(this.deposit) || {}
        this.isWaived = lodash.get(data, 'isWaived', false)
        this.isDirect = lodash.get(data, 'isDirect', true)
        this.amount = normalizeDepositAmount(data.amount)
        this.payeeName = data.payeeName || ''
        this.address = data.address || ''
        this.showFieldValidationErrors()
      },
      immediate: true,
    },
  },
  async mounted () {
    const { buildingOptions, tenantProjectId } = await initTenantProjectDepositSync({
      getBuildingFloorZoneMap,
      routeId: this.$route.params.id,
      addStorageListener: () => {
        window.addEventListener('storage', this.handleTenantProjectDepositSync)
        return () => window.removeEventListener('storage', this.handleTenantProjectDepositSync)
      },
    })
    this.buildingOptions = buildingOptions
    this.tenantProjectId = tenantProjectId
    this.showFieldValidationErrors()
  },
  beforeDestroy () {
    window.removeEventListener('storage', this.handleTenantProjectDepositSync)
  },
  methods: {
    ...mapActions('tenantProject', ['loadTenantProject']),
    ...mapMutations('workPermit', {
      updateECircularOneAttribute: mutationTypes.ECIRCULAR_UPDATE_ONE_ATTRIBUTE,
    }),
    updateAmount (val) {
      this.amount = val
      this.scheduleDirtyStateCheck()
    },
    showFieldValidationErrors () {
      this.$nextTick(() => {
        // Tab selection via EventBus runs after ~100ms; wait so inputs are visible before showing tooltips.
        setTimeout(() => {
          if (!(this.deposit && this.deposit.updatedAt) || !this.isEngineer) {
            return
          }
          const selectors = []
          if (!this.isWaived) {
            selectors.push('.input-deposit-amount')
          }
          if (!this.isDirect) {
            selectors.push('.tenant-mailing-address')
          }
          if (selectors.length) {
            validateProjectControlFieldsOnLoad(...selectors)
          }
        }, 150)
      })
    },
    resetAmount () {
      this.amount = ''
      this.isDirect = true
      this.resetTenantMailing()
      fusionInputCheckUtil.resetInputFiled('.input-deposit-amount input')
      this.scheduleDirtyStateCheck()
    },
    updatePayeeName (val) {
      this.payeeName = val
      this.scheduleDirtyStateCheck()
    },
    updateAddress (val) {
      this.address = val || ''
      this.scheduleDirtyStateCheck()
    },
    resetTenantMailing () {
      this.payeeName = ''
      this.address = ''
      this.buildingErr = false
      fusionInputCheckUtil.resetInputFiled('.input-tenant-mailing-address input')
      this.scheduleDirtyStateCheck()
    },
    scheduleDirtyStateCheck () {
      this.$nextTick(() => {
        window.setTimeout(() => {
          this.$emit('dirty-state-change')
        }, 0)
      })
    },
    validate () {
      if (!this.isWaived) {
        fusionInputCheckUtil.validateAllFields({allowEmpty: 'none'}, '.input-deposit-amount')
      }
      if (!this.isDirect) {
        fusionInputCheckUtil.validateAllFields({allowEmpty: 'none'}, '.tenant-mailing-address')
        this.buildingErr = !this.address
      }
      if (!this.validateAmountBeforeSave()) {
        return false
      }
      return fusionInputCheckUtil.isAllFieldsValid('.deposit-amount') && (this.isDirect || !this.buildingErr)
    },
    validateAmountBeforeSave () {
      if (this.isWaived || isPersistableDepositRefundAmount(this.amount)) {
        return true
      }
      fusionInputCheckUtil.validateAllFields({allowEmpty: 'none'}, '.input-deposit-amount')
      notification.error(this.$t('tenantProjects.correctAmountBeforeSave'))
      return false
    },
    notifyAccounting () {
      if (!this.isWaived && !this.canUpdate && !this.amount) {
        notification.error(this.$t('tenantProjects.emptyToNotifyHint'))
        return
      }
      if (this.validate()) {
        this.openModal()
      }
    },
    closeModal () {
      this.accountingEmail = ''
      fusionInputCheckUtil.resetInputFiled('.input-accounting-email input')
      this.$refs['deposit-input-modal'].close()
    },
    async openModal () {
      this.accountingEmail = await getRegionEnvsByCode('mail.accountingMail')
      const isEmptyObject = typeof this.accountingEmail === 'object' && !Object.keys(this.accountingEmail).length
      if (!this.accountingEmail || isEmptyObject) {
        notification.error(i18n.t('error.getAccountingEmail.system'))
        return
      }
      this.$refs['deposit-input-modal'].open()
    },
    async uploadDepositInfo (type, { extraRequest = {}, requestHandler = tenantProjectApi.updateDepositRefund } = {}) {
      const request = {
        isWaived: this.isWaived,
        isDirect: this.isDirect,
        amount: this.amount ? this.amount : null,
        payeeName: this.payeeName,
        address: this.address,
        updatedBy: lodash.get(this, 'deposit.updator.id'),
      }
      if (this.isModified()) {
        request.updatedAt = new Date()
        request.updatedBy = this.currentUser.id
      }
      const actionHistory = lodash.cloneDeep(this.deposit.actionHistory)
      actionHistory.unshift({
        actionType: type,
        user: {
          id: this.currentUser.id,
          username: this.currentUser.username,
          displayName: this.currentUser.displayName,
        },
        amount: this.amount ? this.amount : null,
        isNewRec: true,
      })
      request.actionHistory = actionHistory
      const result = await requestHandler(this.deposit.id, {
        ...request,
        ...extraRequest,
      })
      if (!result) {
        return null
      }
      await this.loadTenantProject(this.tenantProjectId)
      return result
    },
    async saveAndContinue () {
      const result = await syncSaveDepositAmount({
        validate: this.validateAmountBeforeSave,
        uploadSaveInfo: this.uploadSaveAndContinueInfo,
        hasDirtySaveFields: () => this.hasDirtySaveFields(),
        resetDirty: () => formUtils.resetDirty(FORM_SRC_PROJECT_CONTROL),
      })
      if (result) {
        this.isEditingAmount = false
      }
      return result
    },
    getSaveFieldValues () {
      return pickSaveFieldValues(DEPOSIT_SAVE_FIELDS, this, {
        amount: normalizeDepositAmount,
      })
    },
    hasDirtySaveFields () {
      return this.getModifiedSaveFieldsForSave().length > 0
    },
    getModifiedSaveFieldsForSave () {
      return getModifiedSaveFields(this.deposit, this.getSaveFieldValues(), DEPOSIT_SAVE_FIELDS)
    },
    validateSaveAndContinue () {
      if (!this.validateAmountBeforeSave()) {
        return false
      }
      return validateModifiedSaveFields({
        record: this.deposit,
        local: this.getSaveFieldValues(),
        fields: DEPOSIT_SAVE_FIELDS,
        fieldValidators: DEPOSIT_SAVE_FIELD_VALIDATORS,
        groupValidators: DEPOSIT_SAVE_VALIDATOR_GROUPS,
        context: this,
      })
    },
    async uploadSaveAndContinueInfo ({ skipReload = false } = {}) {
      const request = buildDirtyFieldSaveRequest({
        record: this.deposit,
        local: this.getSaveFieldValues(),
        fields: DEPOSIT_SAVE_FIELDS,
        currentUser: this.currentUser,
        actionType: DEPOSIT_HISTORY_TYPE.saveDepositAmount,
      })
      if (!request) {
        return true
      }
      const result = await tenantProjectApi.updateDepositRefund(this.deposit.id, request)
      if (!result) {
        return null
      }
      if (!skipReload) {
        await this.loadTenantProject(this.tenantProjectId)
      }
      return result
    },
    async notifyPM () {
      this.isEditingAmount = false
      await syncNotifyPm({
        validate: this.validate,
        uploadInfo: this.uploadDepositInfo,
        notifyType: DEPOSIT_HISTORY_TYPE.notifyPM,
        resetDirty: () => formUtils.resetDirty(FORM_SRC_PROJECT_CONTROL),
        sendEmail,
        emailType: EmailTypes['tenantProjects'].depositNotifyPM,
        tenantProjectId: this.tenantProjectId,
        syncAction: TENANT_PROJECT_DEPOSIT_SYNC_ACTION.depositNotifyPM,
      })
    },
    validateAccounting () {
      fusionInputCheckUtil.validateAllFields({allowEmpty: 'none'}, '.input-accounting-email')
      return fusionInputCheckUtil.isAllFieldsValid('.input-accounting-email')
    },
    async sendEmailToAccounting () {
      this.isEditingAmount = false
      if (this.isWaived) {
        return
      }
      if (!this.validateAmountBeforeSave()) {
        return
      }

      await syncDepositNotifyAccounting({
        validateAccounting: this.validateAccounting,
        buildEmails,
        uploadDepositInfo: this.uploadDepositInfo,
        resetDirty: () => formUtils.resetDirty(FORM_SRC_PROJECT_CONTROL),
        closeModal: this.closeModal,
        tenantProjectId: this.tenantProjectId,
        emailType: EmailTypes['tenantProjects'].depositNotifyAccounting,
        requestHandler: tenantProjectApi.notifyAccountingDepositRefund,
        emailPayload: buildDepositNotifyAccountingEmailPayload({
          deposit: this.deposit,
          amount: this.amount,
          isDirect: this.isDirect,
          payeeName: this.payeeName,
          address: this.address,
          chequeFiles: this.chequeFiles,
          currency: this.$globalProps.getCurrency(),
          email: this.accountingEmail,
        }),
      })
    },
    async handleTenantProjectDepositSync (event) {
      await reloadTenantProjectOnDepositSync({
        event,
        tenantProjectId: this.tenantProjectId,
        loadTenantProject: this.loadTenantProject,
      })
    },
    updateAccountingEmail (val) {
      this.accountingEmail = val
    },
    isModified () {
      return this.deposit.amount !== this.amount || this.deposit.address !== this.address ||
      this.deposit.payeeName !== this.payeeName || lodash.get(this, 'deposit.isWaived') !== this.isWaived
    },
    getNotifyInfo (type) {
      const actionHistory = lodash.get(this.deposit, 'actionHistory', [])
      let info = ''
      if (type !== 'confirm') {
        for (let i = 0, len = actionHistory.length; i < len; i++) {
          if (actionHistory[i].actionType === type) {
            info = {
              by: actionHistory[i].user.displayName,
              time: dateUtil.formatDate(actionHistory[i].updatedAt, true),
            }
            break
          }
        }
      } else {
        // confirm type must be the last one in the actionHistory, or they are not available
        const lastOperation = actionHistory[0]
        if (lastOperation && lastOperation.actionType === 'confirm') {
          info = {
            by: lastOperation.user.displayName,
            time: dateUtil.formatDate(lastOperation.updatedAt, true),
          }
        }
      }
      return info
    },
    async confirm () {
      if (this.validate()) {
        this.isEditingAmount = false
        await this.uploadDepositInfo(DEPOSIT_HISTORY_TYPE.confirm)
        formUtils.resetDirty(FORM_SRC_PROJECT_CONTROL)
        this.closeModal()
      }
    },
    async allowContractorRefund () {
      await syncAllowContractorRefund({
        uploadDepositInfo: this.uploadDepositInfo,
        tenantProjectId: this.tenantProjectId,
      })
    },
  },
}
</script>

<style lang='scss'>
@import '~styles/settings';
.waived-option {
  input {
    display: inline;
  }
  .deposit-amount-label {
    margin-right: 0;
    display: inline;
  }
}
.deposit-amount {
  position: relative;
  .deposit-amount-label{
    font-weight: normal
  }
  .currency-prefix {
    display: inline-block;
  }
  .input-field {
    display: inline-block;
  }
  .waived-option {
    margin-top: 15px;
    .plsSendTo {
      display: inline-block;
      margin: 5px 0;
    }
  }
  .btns {
    text-align: right;
    float: right;
    i {
      display: block;
      font-size: 12px;
    }
  }
  .multiselect {
    width: 120px;
    display: inline-block;
  }
  .deposit-notify-info {
    margin-top: 6px;
  }
  .input-tenant-mailing-address {
    width: 200px;
    margin-left: 0.5rem;
    margin-right: 2px;
  }
  .tenant-mailing-address {
    display: flex;
    align-items: center;
    margin-top: 5px;
  }
  .tenant-mailing-address-ro {
    margin-left: 0.5rem;
    margin-right: 2px;
  }
  .tenant-mailing-address__buidling {
    width: 120px !important;
    flex: 0 0 120px;
    display: inline-block;
    margin-left: 5px;
    margin-right: 5px;
  }
  .multiselect {
    border: solid 1px #B5B5B5;
    opacity: 1;
  }
  .multiselect--disabled {
    input:disabled, .multiselect__select {
      background: #E6E6E6;
      background-color: #e6e6e6;
    }
  }
  .error-highlight {
    .multiselect {
      border: 1px solid $red;
      background: #f9ecea;
      input {
        background: #f9ecea;
      }
    }
  }
  .choose-deposit-amount {
    margin-top: 5px;
    .input-field {
      vertical-align: middle;
    }
  }
  .notify-contractor {
    margin: 50px 0;
  }
}
</style>
